var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center relative"},[_c('svg',{staticClass:"flex-none absolute icon",attrs:{"width":"24","height":"24"}},[_c('use',{attrs:{"xlink:href":`#${_vm.icon}`}})]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }